import type { ReactElement } from 'react'
import type { IBlockProps } from '~/types/template'

import SimpleBlock from '../Block'

const TextBlock = (props: IBlockProps): ReactElement => <SimpleBlock {...props} type="text" />

export default TextBlock
